import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AddQuestion, GetQuestionById, GetAllLevels } from '../services/questionservice';
import { GetAllSubjects } from '../services/isubjectservice';
import '../code.css';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

function QuestionNew() {
    const [pk, setPk] = useState(0);
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [subject, setSubject] = useState('');
    const [subjectpk, setSubjectPk] = useState(0);
    const [qlevels, setQLevels] = useState([]);
    const [level, setLevel] = useState('');
    const [iscode, setIsCode] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('pk') || null;
    
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean'],
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'font', 'align',
        'list', 'bullet', 'indent',
        'blockquote', 'code-block',
        'link', 'image', 'video',
    ];

    useEffect(() => {
        fillSubject();
        fetchQLevels();
        if (id) {
            fillData(id);
            setPk(id);
        }
    }, [id]);

    const fillData = async (questionPk) => {
        const data = await GetQuestionById(questionPk);
        const jsonData = JSON.parse(data);
        setQuestion(jsonData.question);
        setAnswer(jsonData.answer);
        setSubjectPk(jsonData.isubjectpk);
        setLevel(jsonData.qlevel);
        setIsCode(jsonData.iscode);
    };

    const handleSave = async () => {
        const postBody = JSON.stringify({
            pk: pk,
            question: question,
            answer: answer,
            isubjectpk: subjectpk,
            qlevel: level,
            iscode: iscode,
            mediapk: 0,
            deleted: false,
            updatedby: 0,
            addedby: 0,
            updatedon: new Date().toISOString(),
            addedon: new Date().toISOString()
        });

            try {
                const response = AddQuestion(postBody);
                if(pk == 0)
                    navigate('/question', { state: { successMessage: 'New question added' } });
                else
                    navigate('/question', { state: { successMessage: 'Question updated' } });
    
            } catch (error) {
                console.error('Error fetching the data:', error);
            }
    }
    const fetchQLevels = async () => {
            const data = await GetAllLevels();
            const jsonLevelList = JSON.parse(data);
            setQLevels(jsonLevelList || []);
        };

    const fillSubject = async () => {
            try {
                const dataList = await GetAllSubjects();
                const jsonDataList = JSON.parse(dataList);
                setSubject(jsonDataList);
            } catch (error) {
                console.error('Error fetching the data:', error);
            }
    }

    const handleCancel = async () => {
        navigate('/question/');
    }

    const handleChange = (e) => {
        const clickedValue = e.target.checked;
        setIsCode(clickedValue);
    };

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new question</h4>
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtQuestion">Question</label>
                                    <input type="text" class="form-control" id="txtQuestion" onChange={(e) => setQuestion(e.target.value)} placeholder="Question" value={question} />
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtMedia">Subject</label>
                                            <select class="form-control dropdown" onChange={(e) => setSubjectPk(e.target.value)}  value={subjectpk}>
                                                <option value="">Subject</option>
                                                {subject && subject.map((item) => (
                                                    <option value={item.pk}>{item.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtLevel">Question Level</label>
                                            <select class="form-control dropdown" onChange={(e) => setLevel(e.target.value)}  value={level}>
                                                <option value="">Level</option>
                                                {qlevels && qlevels.map((item) => (
                                                    <option value={item.key}>{item.value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                                 <div class="form-group">
                                    <label for="txtQuestion" className='checkbox-label'>Is Code?</label>
                                    <input
                                        type="checkbox"
                                        name="txtcode"
                                        checked={iscode} 
                                        onChange={handleChange}
                                    />
                                </div>
                                <div class="form-group"> </div>
                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave()}>Save</button>
                                <button class="btn btn-light" onClick={() => handleCancel()}>Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtTitle">Answer</label>
                                    <ReactQuill
                                        theme="snow"
                                        value={answer}
                                        onChange={(answer) => setAnswer(answer)}
                                        modules={modules}
                                        formats={formats}
                                        placeholder="Start typing..."
                                        height={200}
                                    />
                                    <div className="output">
                                        <h3>Output HTML:</h3>
                                        <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: answer }} />
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default QuestionNew;